// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"222":"ad6f40bd","234":"af7473a6","453":"677419f5","455":"9148de37","974":"26547ea9","977":"7168d186"}[chunkId] + ".chunk.js";
};